export const MIN_ZIP_CODE_LENGTH = 5;
export const MAX_ZIP_CODE_LENGTH = 5;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 30;
export const MAX_PASSWORD_LENGTH_EPIX = 34;
export const MAX_COMMENT_LENGTH = 10000;
export const MAX_WATCHLIST_NAME_LENGTH = 250;
export const MAX_APP_COST = 999999;
